import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'
import googleLogoIconImage from 'google-logo-icon.png'

JobWizardMobile.EnterEmailAddress = {
  validator: '',

  onSubmit: function(onStepProgression, onRequest, onRequestCompletion, onStepRetreat) {
    let emailCheck = () => {
      $.ajax(SS.API.V3.userCheckEmail(Job.Data.emailAddress)).fail(function () {
        document.location = "/500"
      }).done((response) => {
        const result = response.meta

        if (result.status === 'true') {
          Job.Actions.updateMustCreateAccount(false)
          Job.Actions.updateFirstName(result.name)
          Job.Actions.updatePhoneNumber(result.phone)
          SS.currentUserStatus = result.userStatus
          onStepProgression()
        } else if (result.status === 'valid') {
          Job.Actions.updateMustCreateAccount(true)
          onStepProgression()
        } else if (result.status === 'invalid') {
          this.validator.updateMessage('email_address', 'notEmpty', result.error || 'Please enter a valid email address.')
          this.validator.updateStatus('email_address', 'INVALID', 'notEmpty')
        }
      })
    }

    JobWizardMobile.EnterEmailAddress.validator.validateField('email_address') && emailCheck()
  },

  onLeftNavButtonClick(onStepProgression) {
    $('#job-modal').data('bootstrapValidator').removeField('email_address')
    JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.EnterDescription)
  },

  component: React.createClass({
    getInitialState: function() {
      return {
        emailAddress: Job.Data.emailAddress,
      }
    },

    componentDidMount: function() {
      $('#job-modal').bootstrapValidator({ /* */ })
      JobWizardMobile.EnterEmailAddress.validator = $('#job-modal').data('bootstrapValidator')
      this.setupValidation()
    },

    setupValidation: function () {
      JobWizardMobile.EnterEmailAddress.validator.addField('email_address', {
        threshold: 9999999,
        validators: {
          notEmpty: {
            message: 'Please enter an email address'
          }
        }
      })
    },

    handleEmailAddressChange: function(e) {
      let emailAddressOriginal = e.target.value
      let emailAddressTrimmed = e.target.value.replace(/[\s]/g, '')

      if (emailAddressOriginal !== emailAddressTrimmed) {
        e.target.value = emailAddressTrimmed
      }
      
      this.setState({ emailAddress: emailAddressTrimmed })
      Job.Actions.updateEmailAddress(emailAddressTrimmed)
      Job.Actions.updateOtp(null)
      Job.Actions.resetOmniAuthDetails()
      Job.Actions.updateOmniAuthDetails({'account_from_omni_auth': false})
      Job.Actions.updateOmniAuthProvider(null)
    },

    handleOmniAuthClick: function(e) {
      $('#job-modal').data('bootstrapValidator').removeField('email_address')
      Job.Actions.updateOmniAuthDetails({'account_from_omni_auth': true})
      Job.Actions.updateOmniAuthProvider(e.currentTarget.value)
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.LoginOmniauth)
    },

    render: function() {
      return (
        <div>
          <div>
            <h3 className="mb8 mt10">What email address would you like your quotes sent to?</h3>
            <small className="info-text mb8">
              <i className="block">
                name@sample.com
              </i>
            </small>
            <div className="form-group">
              <div className="input-group p5 border radius-6 details-mobile">
                <span>
                  <input type="text" className="form-control" id="email_address"
                    name="email_address"
                    defaultValue={this.state.emailAddress}
                    onChange={this.handleEmailAddressChange}
                  />
                </span>
                <span className="input-group-btn">
                  <JobWizardMobile.NavigationButtons
                    navButtonLayout='okButton'
                    onStepProgression={this.props.onStepProgression}
                  />    
                </span>
              </div>
            </div>
            <div>
              <p className={`text-copy-0 pb8 text-center ${JobWizardMobile.MessageChannel.hasMobileChannel() ? 'hidden' : ''}`} ><i className="ficon-minus"/><b> OR </b><i className="ficon-minus"/></p>
              <button className={`btn btn-facebook btn-clear btn-lg btn-block ${JobWizardMobile.MessageChannel.hasMobileChannel() ? 'hidden' : ''}`} type="button" id="btn-facebook-modal" onClick={this.handleOmniAuthClick} value='Facebook'>
                <div className="i ficon-facebook text-white">
                  <span className="pl8">Login with Facebook</span>
                </div>
              </button>
              <button className={`btn btn-clear btn-block ${JobWizardMobile.MessageChannel.hasMobileChannel() ? 'hidden' : ''}`} type="button" id="btn-google-modal" onClick={this.handleOmniAuthClick} value='Google'>
                <img className="img-google" src={googleLogoIconImage}/>
                <span className="pl8">Sign in with Google</span>
              </button>
            </div>
          </div>
        </div>
      )
    }
  })
}
